module.exports = __webpack_public_path__ + "img/user_group.2dd11467.svg";